import { uploadConst } from '../consts';

export function upload(state = {}, action) {
    switch (action.type) {
        case uploadConst.UPLOAD_REQUEST:
            return {
                ...state,
                [action.requestId]: { ...state[action.requestId], [action.file.id]: { ...action.file, progress: 0 } }
            };
        case uploadConst.UPLOAD_SUCCESS: {
            const { [action.file.id]: _, ...files } = state[action.requestId];
            return { ...state, [action.requestId]: files };
        }
        case uploadConst.UPLOAD_FAILURE:
            return {
                ...state,
                [action.requestId]: {
                    ...state[action.requestId],
                    [action.file.id]: { ...action.file, errors: action.errors }
                }
            };
        case uploadConst.UPLOAD_PROGRESS: {
            return {
                ...state,
                [action.requestId]: { ...state[action.requestId], [action.file.id]: { ...action.file } }
            };
        }
        case uploadConst.UPLOAD_CANCEL: {
            const { [action.file.id]: _, ...files } = state[action.requestId];
            return { ...state, [action.requestId]: files };
        }
        default:
            return state;
    }
}
